import React, { useState, useEffect } from 'react';
import './EmpresaN.css';
import { getUserById, updateUser } from './general/api'; // Importamos la función para obtener y actualizar usuario
import { useDispatch } from 'react-redux';
import { setMenu } from '../actions/index';

const UsuarioUpd = ({ userData }) => {
  const Id_User = userData[0]?.Id_User; // Asegurar que hay un usuario seleccionado
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [error, setError] = useState(null); // Estado para errores

  // Cargar los datos del usuario desde la API al cargar el componente
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        setError(null);

        const userInfo = await getUserById(Id_User); // Llama la función de API
        setOriginalData(userInfo); // Guardar datos originales para comparar
        setFormData({
          id: userInfo.Id_User || '',
          name: userInfo.Name_User || '',
          identificacion: userInfo.Cc_User || '',
          email: userInfo.Email_User || '',
          tel: userInfo.Tel_User || '',
          cargo: userInfo.Cargo_User || '',
          password: '', // Contraseña ficticia, mostrada como vacía
          access_lvl: userInfo.Id_Access || '1',
          company_id: userInfo.Id_Empresa || '',
        });
      } catch (err) {
        console.error('Error al cargar datos del usuario:', err);
        setError('Error al cargar los datos del usuario.');
      } finally {
        setLoading(false); // Desactiva el indicador de carga
      }
    };

    if (Id_User) {
      fetchUserData(); // Llamamos la función solo si tenemos un ID
    }
  }, [Id_User]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Crear un objeto con solo los datos modificados
    const updatedData = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== originalData[key] && key !== 'password') {
        updatedData[key] = formData[key];
      }
    });

    // Añadir la contraseña solo si fue modificada
    if (formData.password !== '') {
      updatedData.password = formData.password;
    }

    // Verificar si hay datos para enviar
    if (Object.keys(updatedData).length === 0) {
      alert('No se realizaron cambios.');
      return;
    }

    try {
      const response = await updateUser(updatedData); // Enviar datos actualizados
      console.log(response);
      alert('Usuario actualizado con éxito');
      dispatch(setMenu('usuarioAct')); // Navegar al listado de usuarios
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      alert('Ocurrió un error al actualizar el usuario.');
    }
  };

  if (loading) {
    return <p>Cargando datos del usuario...</p>;
  }

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }

  return (
    <div className="empresaN">
      <h2>Actualizar Usuario</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nombre:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </label>
        <label>
          Identificacion:
          <input
            type="text"
            name="identification"
            value={formData.identificacion}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </label>
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </label>
        <label>
          Teléfono:
          <input
            type="text"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </label>
        <label>
          Cargo:
          <input
            type="text"
            name="cargo"
            value={formData.cargo}
            onChange={handleChange}
            autoComplete="off"
            required
          />
        </label>
        <label>
          Nivel de Acceso:
          <select
            name="access_lvl"
            value={formData.access_lvl}
            onChange={handleChange}
            required
          >
            <option value="1">Nivel 1</option>
            <option value="2">Nivel 2</option>
            <option value="3">Nivel 3</option>
          </select>
        </label>
        <label>
          Empresa Asociada:
          <input
            type="text"
            name="company_id"
            value={formData.company_id}
            onChange={handleChange}
            autoComplete="off"
            disabled
          />
        </label>
        <label>
          Contraseña (solo si deseas cambiarla):
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="off"
          />
        </label>
        <button type="submit">Actualizar Usuario</button>
      </form>
    </div>
  );
};

export default UsuarioUpd;
